import { InputBase, withStyles } from '@material-ui/core';

const BootstrapInput = withStyles(() => ({
  input: {
    position: 'relative',
    backgroundColor: '#fff',
    padding: '5px 0px 0px 11px',
    fontSize: 13,
    maxHeight: 32,
    fontFamily: ['Roboto', 'sans-serif'].join(','),
  },
}))(InputBase);
export default BootstrapInput;
